__turbopack_context__.v({
  "ActionButtons": "index-module__xwxOYa__ActionButtons",
  "Clear": "index-module__xwxOYa__Clear",
  "Empty": "index-module__xwxOYa__Empty",
  "Input": "index-module__xwxOYa__Input",
  "InputGroup": "index-module__xwxOYa__InputGroup",
  "Item": "index-module__xwxOYa__Item",
  "ItemEmail": "index-module__xwxOYa__ItemEmail",
  "ItemIndicator": "index-module__xwxOYa__ItemIndicator",
  "ItemSubtitle": "index-module__xwxOYa__ItemSubtitle",
  "ItemText": "index-module__xwxOYa__ItemText",
  "ItemTitle": "index-module__xwxOYa__ItemTitle",
  "Label": "index-module__xwxOYa__Label",
  "Popup": "index-module__xwxOYa__Popup",
  "Positioner": "index-module__xwxOYa__Positioner",
  "Spinner": "index-module__xwxOYa__Spinner",
  "Status": "index-module__xwxOYa__Status",
  "Trigger": "index-module__xwxOYa__Trigger",
  "Viewport": "index-module__xwxOYa__Viewport",
  "comboboxSpinner": "index-module__xwxOYa__comboboxSpinner",
});
